// 200 Indicates that warranty can be searched but is not bound.
export enum WarrantyStatusEnum {
  ActiveAndUnbound = 200,
  NotFound = 801,
  RegisteredByOther = 811,
  RegisteredBySelf = 810,
}
